import { tss } from "tss-react";

export const headerHeight = 64;
export const viewsHeaderHeight = 50;
export const defaultBorderColor = "#E5E9F1";
export const boxShadow = "0px 10px 7px 0 #0000000d";
export const boxShadow2 = "0 1px 0 0 " + defaultBorderColor;
export const boxShadow3 = "inset 0px 10px 13px #0000000f";
export const boxShadow4 = "0px -1px 0px 0px #E9ECEF inset";
export const defaultBorder = "solid 1px " + defaultBorderColor;
export const fontFamily = "Roboto";
export const spacing = 26;
export const rightMargin = 24;
export const primaryColor = "#2B3467";
export const primarySelectedColor = "#28ABE3 !important";
export const secondarySelectedColor = "#FFC800";
export const primaryLabelColor = "#283C50";
export const breadCrumbsTextColor = "#272727 !important";
export const breadCrumbsTextSize = "24px !important";
export const breadCrumbsTextFont = "600 !important";
export const selectedLayerColor = "#002776";
export const folderColor = "#ffc248";
export const hoverColor = "#CCD4E4";
export const panelHeaderHeight = 46;
export const panelWidth = 280;
export const panelBackgroundColor = "#fcfcfc";
export const backgroundColor = "#f7f7f7eb";
export const panelHeaderColor = "#f7f7f7";
export const sectionHeaderColor = "#f7f7f7";
export const viewCardBackground = "#ffffff !important";
export const toolbarBackground = "#a0a0a0FF";
export const buttonsColor = "rgba(0, 0, 0, 0.54)";
export const menuItemButtonsColor = "rgba(255,255,255, .8)";
export const menuItemWidth = "90%";
export const labelColor = "#000000";
export const rowHeight = 40;
export const drawerWidth = 240;
export const drawerWidthClosed = 56;
export const iconColor = "rgb(0,0,0,0.53)";

const useStyles: any = tss.create((theme: any) => ({
    root: {
        height: "85%",
    },
    header: {
        position: "relative",
        display: "inline-flex",
        flexDirection: "row",
        paddingLeft: 20,
        height: viewsHeaderHeight,
        alignItems: "center",
        borderBottom: defaultBorder,
        verticalAlign: "top",
        backgroundColor: "#f7f7f7",
    },
    label: {
        color: primaryLabelColor,
        fontFamily: fontFamily,
        fontSize: 14,
        letterSpacing: 0,
        lineHeight: "16px",
    },
    verySmallLabel: {
        color: primaryLabelColor,
        fontSize: 10,
        letterSpacing: 0.33,
        lineHeight: "11px",
    },
    smallLabel: {
        color: primaryLabelColor,
        fontSize: 12,
        letterSpacing: 0.21,
        lineHeight: "14px",
    },
    mediumLabel: {
        color: primaryLabelColor,
        fontSize: 14,
        letterSpacing: 0.1,
        lineHeight: "16px",
    },
    largeLabel: {
        color: primaryLabelColor,
        fontSize: 16,
        letterSpacing: 0.15,
        lineHeight: "18px",
    },
    button: {
        borderRadius: 0,
        display: "inline-flex",
        width: 24,
        height: 24,
        alignItems: "center",
        justifyContent: "center",
        minWidth: 20,
    },
    buttonOutline: {
        color: "#283C50",
    },
    shaded: {
        color: "#3D4F61",
    },
    white: {
        color: "#ffffff",
    },
    selected: {
        color: "#FFC800",
    },
    grey: {
        color: "rgba(170, 170, 170, 0.25)",
    },
    background: {
        color: toolbarBackground,
    },
    disabled: {
        opacity: 0.25,
    },
    pointer: {
        cursor: "pointer",
    },
    disabledEvents: {
        opacity: 0.25,
        pointerEvents: "none",
        cursor: "default",
    },
    disableEventsNoShades: {
        pointerEvents: "none",
        cursor: "default",
    },
    disabledGrayEvents: {
        color: "silver",
        pointerEvents: "none",
        cursor: "default",
    },
    closeButton: {
        color: "rgb(170,170,170)",
        width: 16,
        height: 16,
        verticalAlign: "middle",
        display: "inline-block",
    },
    center: {
        display: "inline-flex",
        justifyContent: "center",
        width: "100%",
    },
    middle: {
        display: "inline-flex",
        alignItems: "center",
    },
    middleCenter: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
    },
    verticalMiddle: {
        display: "flex",
        alignItems: "center",
    },
    verticalMiddleCenter: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    tabs: {
        width: 276,
        minHeight: "35px !important",
        //border: defaultBorder,
        borderRadius: "5px 5px 0 0",
    },
    tab: {
        fontSize: "11px !important",
        minWidth: "130px !important",
        minHeight: "30px !important",
    },
    spacing: {
        marginLeft: spacing,
        marginRight: spacing,
    },
    spacingRight: {
        marginRight: spacing,
    },
    right: {
        position: "absolute",
        right: rightMargin,
    },
    primarySelectedColor: {
        color: primarySelectedColor
    },
    menuDivider: {
        backgroundColor: "rgba(229,233,241, 0.3)", 
        border: "none", 
        height: 1, 
        margin: 0, 
        flexShrink: 0 
    },
    topSpace:{
        marginTop: '100%'
    },
    primarySelectedBgColor:{
        backgroundColor: "#fff",
        width: "100% !important",
        margin: "0 auto"
    },
    primaryWhiteColor:{
        color : "#fff"
    },
    primarySelectedBgNoColor:{
        width: "100% !important",
        margin: "0 auto"
    },
    secondarySelectedColor: {
        color: secondarySelectedColor,
    },
    sectionContent: {
        padding: 12,
        backgroundColor: backgroundColor,
        boxShadow: boxShadow,
    },
    buttonsColor: {
        color: buttonsColor,
    },
    icon: {
        width: 27,
        height: 27,
        marginRight: 10,
        color: iconColor,
    },
    row: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        height: 40,
        width: "100%",
    },
    customSelect: {
        color: "black",
        width: "100%",
        fontSize: 14,
    },
    subSectionLabel: {
        fontSize: 14,
        color: "#283C50",
        letterSpacing: 0,
        lineHeight: "16px",
    },
    numberInput: {
        color: "black",
        textAlign: "right",
        fontSize: 14,
        marginTop: 0,
    },
    blueButton : {
        cursor: 'pointer', 
        borderRadius:'5px', 
        display : "flex", 
        alignItems: "center", 
        justifyItems : "center", 
        padding: "2px 20px", 
        background: "#3B82F7", 
        color:"#fff",
        fontSize : '13px',
    },
    whiteButton : {
        cursor: 'pointer', 
        borderRadius:'2px', 
        display : "flex", 
        alignItems: "center", 
        justifyItems : "center", 
        padding: "2px 20px", 
        background: "#fff", 
        color:"#000",
        fontSize : '13px',
    }
}));
export default useStyles;
